import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Form, Modal, Table } from "react-bootstrap";
import { X, Trash, Check, Plus, List, PlusSquare } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { setServiceComboItemsPop } from "../../store/api/Modals";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

const ModalServiceComboItems = () => {
    const popup = useSelector(state => state.popup.popServiceCmbItems);
    const { show, items, setValue } = popup;
    let tempArray = items?.split("|") ?? [];
    const [itemArray, setArray] = useState([]);
    const dispatch = useDispatch();
    const addedItem = useRef();
    const close = () => {
        setArray();
        dispatch(setServiceComboItemsPop({ show: false }));
    }
    const removeFromList = (item) => {
        const arr = itemArray.filter(i => i !== item);
        setArray(arr);
    }
    const add2List = (e) => {
        if (!addedItem.current || addedItem.current.value === '' || (e.key && e.key !== "Enter")) {
            return;
        }
        const value = addedItem.current.value;
        if (itemArray.indexOf(value) !== -1) {
            return;
        }
        const arr = itemArray.slice();
        arr.push(addedItem.current.value);
        addedItem.current.value = "";
        setArray(arr);
    }
    const submitChanges = () => {
        const itms = itemArray.join("|");
        if (setValue) {
            setValue(itms);
        }
        close();
    }
    useEffect(() => {
        if (show) {
            setArray(tempArray);

        }
    }, [show]);
    return (
        <Modal show={show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className="headerStyle"><span><List color="white" size={20} />&nbsp;آیتم های لیستی</span><FontAwesomeIcon icon={faTimes} onClick={close} size="lg" /></Modal.Header>
            <Modal.Body className="bodyStyle">
                <div className="form-group">
                    <Form.Control ref={addedItem} style={{ width: "80%", display: "inline-block" }} onKeyDown={add2List} />
                    <Button className="group-Btn-smalll" onClick={add2List}><PlusSquare size={22} /></Button>
                </div>
                {Array.isArray(itemArray) && itemArray.length > 0 &&
                    <Fragment>
                        <Table className="mt-2">
                            <thead>
                                <tr>
                                    <th style={{ padding: 0 }}></th>
                                    <th style={{ padding: 0 }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {itemArray.map((item, i) =>
                                    item !== '' ?
                                        <tr className="resultTableRow" key={i}>
                                            <td>{item}</td>
                                            <td style={{ width: "30px" }}><Trash color="red" size={14} onClick={() => removeFromList(item)} /></td>
                                        </tr>
                                        :
                                        null
                                )}
                            </tbody>
                        </Table>
                    </Fragment>}
                <Button className="group-Btn mt-1" variant="info" onClick={submitChanges}><Check size={18} /> ثبت تغییرات</Button>
            </Modal.Body>
        </Modal>
    )
}
export default ModalServiceComboItems;